import styled from "styled-components";
import { BREAKPOINTS } from "../../helpers/theme";
import { vwDesktop, vwMobile, rem } from "../../helpers/styles";
import Input from "../shared/Input";
import ButtonLink from "../shared/ButtonLink";

export const SectionContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #FDF2D6;
  padding: ${vwMobile(40)} ${vwMobile(20)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${vwDesktop(80)} ${vwDesktop(100)};
  }
`;


export const SectionTitle = styled.h2`
  color: var(--color-green-90);
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${rem(36)};
  line-height: 0.94;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  text-align: center;
  font-weight: 900;
  padding: 0 ${vwMobile(10)};

  strong {
    color: var(--color-green-30);
    font-weight: inherit;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${rem(56)};
    padding: 0 ${vwDesktop(10)};
  }
`;

export const CardsContainer = styled.div`
  margin-top: ${vwMobile(10)};
  display: flex;
  flex-direction: column;
  gap: ${vwDesktop(80)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    flex-direction: row;
    justify-content: center;
    margin-top: ${vwDesktop(40)};
    gap: ${vwDesktop(20)};
    align-items: center;
  }
`;

export const Card = styled.div`
  flex:1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${vwMobile(12)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    max-width: ${vwDesktop(395)};
    gap: ${vwDesktop(24)};
  }
`;

export const Title = styled.h3`
  color: var(--color-green-90);
  font-family: ${(props) => props.theme.fontFamily},
    ${(props) => props.theme.fallBackFontFamily}, sans-serif;
  font-size: ${rem(36)};
  line-height: ${rem(40)};
  letter-spacing: 0.03em;
  text-transform: uppercase;
  font-weight: 900;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${rem(48)};
    line-height: ${rem(56)};
  }
`;

export const Image = styled.img`
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
`;

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${vwMobile(16)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    flex-direction: row;
    gap: ${vwDesktop(20)};
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const SmallButton = styled(ButtonLink)`
  width: 100%;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: ${vwDesktop(180)};
    min-width: ${vwDesktop(85)};
  }
`;

export const BigButton = styled(ButtonLink)`
  width: 100%;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    min-width: ${vwDesktop(85)};
  }
`;
